var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-kline-view"},[_c('StockKLine5Day',{attrs:{"stock-code":_vm.stockCode},on:{"update:stockCode":function($event){_vm.stockCode=$event},"update:stock-code":function($event){_vm.stockCode=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }